import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import "react-toastify/dist/ReactToastify.css";

/* =====================
   AUTH
===================== */
import Login from "../pages/auth/Login";
import RegisterGuru from "../pages/auth/RegisterGuru";
import RequestResetPassword from "../pages/auth/RequestResetPassword";
import ResetPassword from "../pages/auth/ResetPassword";

/* =====================
   ADMIN
===================== */
import AdminDashboard from "../pages/admin/Dashboard";
import DataGuru from "../pages/admin/DataGuru";
import DataSiswa from "../pages/admin/DataSiswa";
import DataMapel from "../pages/admin/DataMapel";
import DataKelas from "../pages/admin/DataKelas";
import DataJadwal from "../pages/admin/DataJadwal";
import LaporanKehadiran from "../pages/admin/Laporan";
import DataPengguna from "../pages/admin/DataPengguna";
import Pengaturan from "../pages/admin/Pengaturan";
import LaporanGuruAbsen from "../pages/admin/LaporanGuruAbsen";

/* =====================
   GURU
===================== */
import DashboardGuru from "../pages/guru/Dashboard";
import ProfilGuru from "../pages/guru/Profil";
import JadwalGuru from "../pages/guru/JadwalGuru";
import Presensi from "../pages/guru/Presensi";
import MonitoringGuru from "../pages/guru/Monitoring";
import Rekapitulasi from "../pages/guru/Rekapitulasi";
import PresensiScanner from "../pages/guru/Scanner";
import PresensiManual from "../pages/guru/Manual";
import JadwalKosong from "../pages/guru/JadwalKosong";

/* =====================
   PIMPINAN
===================== */
import PimpinanDashboard from "../pages/pimpinan/Dashboard";
import Jadwal from "../pages/pimpinan/Jadwal";
import Rekap from "../pages/pimpinan/Rekapitulasi";
import ProfilPimpinan from "../pages/pimpinan/Profil";
// Import komponen Laporan Guru Tidak Hadir versi pimpinan
import LaporanGuruAbsenPimpinan from "../pages/pimpinan/LaporanGuruAbsen"; 

/* =====================
   PETUNJUK
===================== */
import PetunjukAdmin from "../pages/admin/PetunjukAdmin";
import PetunjukGuru from "../pages/guru/PetunjukGuru";
import PetunjukPimpinan from "../pages/pimpinan/PetunjukPimpinan";



/* =====================
   WRAPPER ROLE
===================== */
const Admin = (page) => <ProtectedRoute role="admin">{page}</ProtectedRoute>;

const Guru = (page) => <ProtectedRoute role="guru">{page}</ProtectedRoute>;

const Pimpinan = (page) => (
  <ProtectedRoute role="pimpinan">{page}</ProtectedRoute>
);

export default function AppRoutes() {
  return (
    <Routes>
      {/* AUTH */}
      <Route path="/" element={<Login />} />
      <Route path="/register-guru" element={<RegisterGuru />} />
      <Route
        path="/request-reset-password"
        element={<RequestResetPassword />}
      />
      <Route path="/reset-password/:token" element={<ResetPassword />} />

      {/* ADMIN */}
      <Route path="/admin" element={Admin(<AdminDashboard />)} />
      <Route path="/admin/guru" element={Admin(<DataGuru />)} />
      <Route path="/admin/siswa" element={Admin(<DataSiswa />)} />
      <Route path="/admin/mapel" element={Admin(<DataMapel />)} />
      <Route path="/admin/kelas" element={Admin(<DataKelas />)} />
      <Route path="/admin/jadwal" element={Admin(<DataJadwal />)} />
      <Route path="/admin/laporan" element={Admin(<LaporanKehadiran />)} />
      <Route path="/admin/pengguna" element={Admin(<DataPengguna />)} />
      <Route path="/admin/pengaturan" element={Admin(<Pengaturan />)} />
      <Route path="/admin/guru-absen" element={Admin(<LaporanGuruAbsen />)} />

      {/* GURU */}
      <Route path="/guru" element={Guru(<DashboardGuru />)} />
      <Route path="/guru/profil" element={Guru(<ProfilGuru />)} />
      <Route path="/guru/jadwal" element={Guru(<JadwalGuru />)} />
      <Route path="/guru/presensi" element={Guru(<Presensi />)} />
      <Route path="/guru/monitoring" element={Guru(<MonitoringGuru />)} />
      <Route path="/guru/rekapitulasi" element={Guru(<Rekapitulasi />)} />
      <Route
        path="/guru/presensi/scanner"
        element={Guru(<PresensiScanner />)}
      />
      <Route path="/guru/presensi/manual" element={Guru(<PresensiManual />)} />
      <Route path="/guru/jadwal-kosong" element={Guru(<JadwalKosong />)} />

      {/* PETUNJUK */}
      <Route path="/admin/petunjuk" element={Admin(<PetunjukAdmin />)} />
      <Route path="/guru/petunjuk" element={Guru(<PetunjukGuru />)} />
      <Route
        path="/pimpinan/petunjuk"
        element={Pimpinan(<PetunjukPimpinan />)}
      />

      {/* PIMPINAN */}
      <Route path="/pimpinan" element={Pimpinan(<PimpinanDashboard />)} />
      <Route path="/pimpinan/jadwal" element={Pimpinan(<Jadwal />)} />
      <Route path="/pimpinan/rekap" element={Pimpinan(<Rekap />)} />
      <Route path="/pimpinan/profil" element={Pimpinan(<ProfilPimpinan />)} />
      {/* Route Baru untuk Laporan Guru Absen versi Pimpinan */}
      <Route path="/pimpinan/guru-absen" element={Pimpinan(<LaporanGuruAbsenPimpinan />)} />
    </Routes>
  );
}